import {
  CHECKOUT_SUBMIT,
  CHECKOUT_SUBMIT_ERROR,
  CHECKOUT_SET_DISCOUNT_CODE,
  CHECKOUT_SET_DELIVERY,
  CHECKOUT_SET_PAYMENT,
  CHECKOUT_SET_ORDER_NOTE,
  CHECKOUT_SET_B2C_ZIP_CODE,
  CHECKOUT_SET_B2C_ZIP_CODE_SUCCESS,
  CHECKOUT_ACCEPT_TERMS_OF_CONDITION,
  CHECKOUT_ACCEPT_NEWS_LETTER_SIGN_UP,
  CHECKOUT_SET_PRIVATE_CUSTOMER,
  CHECKOUT_SET_PAYMENT_WIDGET,
  CHECKOUT_SET_SELECTED_COMPANY_ADDRESS,
  CHECKOUT_SET_SIGN_UP,
  CHECKOUT_SET_COUNTRY,
  CHECKOUT_SET_USED_DISCOUNT_CODE,
  CHECKOUT_UPDATE_CUSTOMER_INFO,
  CHECKOUT_SET_SHOW_ALTERNATIVE_ADDRESS,
  CLEAR_ERROR,
  CHECKOUT_SET_STATUS_SUBMIT_BUTTON,
  CHECKOUT_VALIDATE_ADDRESS,
  CHECKOUT_SET_CUSTOMER_INFO,
  CHECKOUT_SET_VALIDATION_ERRORS,
  CHECKOUT_SET_IS_SUBMITTING,
  CHECKOUT_SET_SELECTED_DELIVERY_ADDRESS,
  CHECKOUT_SET_SELECTED_BILLING_ADDRESS,
} from '../constants';
import Address from '../Types/Address';
import { error as errorReducer } from './Error.reducer';
import { AnyAction } from 'redux';

interface CheckoutMethod {
  id: string;
  name: string;
  description: string;
  formattedPrice: string;
  imageUrl?: string;
  integrationType: string;
}

export interface CheckoutState {
  payload: {
    companyName?: string;
    alternativeAddress?: Address;
    customerDetails?: any;
    selectedDeliveryAddressId?: string;
    selectedBillingAddressId?: string;
    selectedDeliveryMethod?: CheckoutMethod;
    selectedPaymentMethod?: CheckoutMethod;
    selectedCountry?: string;
    discountCode?: string;
    orderNode?: string;
    paymentWidget?: any;
    isBusinessCustomer: boolean;
    signUp: boolean;
    acceptTermsOfCondition: boolean;
    acceptNewsLetterSignUp: boolean;
    authenticated: boolean;
    deliveryMethods: CheckoutMethod[];
    paymentMethods: CheckoutMethod[];
    companyAddresses: Address[];
    responseUrl?: string;
    cancelUrl?: string;
    redirectUrl?: string;
    showAlternativeAddress: boolean;
    customerServiceMessage?: {
      value: string;
    };
    termsUrl?: string;
    usedDiscountCodes: string[];
    emptyCartLink?: string;
    emptyCartText?: string;
    loginUrl?: string;
    checkoutUrl?: string;
    message?: string;
    paymentErrorMessage?: string;
  };
  errors: any;
  result: any;
  validationErrors: any;
  checkoutIsSubmitting: boolean;
}

const defaultState: CheckoutState = {
  payload: {
    customerDetails: {},
    discountCode: '',
    paymentWidget: null,
    isBusinessCustomer: false,
    signUp: false,
    acceptTermsOfCondition: false,
    acceptNewsLetterSignUp: false,
    authenticated: false,
    deliveryMethods: [],
    paymentMethods: [],
    companyAddresses: [],
    responseUrl: '',
    cancelUrl: '',
    redirectUrl: '',
    showAlternativeAddress: false,
    usedDiscountCodes: [],
    companyName: '',
  },
  errors: {},
  result: {},
  validationErrors: {},
  checkoutIsSubmitting: false,
};
export const checkout = (
  state = defaultState,
  action: AnyAction
): CheckoutState => {
  const { type, payload } = action;
  switch (type) {
    case CHECKOUT_SUBMIT_ERROR:
      return {
        ...state,
        errors: errorReducer(state.errors, action),
      };
    case CHECKOUT_SET_IS_SUBMITTING:
    case CHECKOUT_SUBMIT:
    case CHECKOUT_SET_STATUS_SUBMIT_BUTTON:
    case CLEAR_ERROR:
    case CHECKOUT_SET_VALIDATION_ERRORS:
      return {
        ...state,
        ...payload,
      };
    case CHECKOUT_UPDATE_CUSTOMER_INFO:
      return {
        ...state,
        payload: {
          ...state.payload,
          [payload.key]: {
            ...state.payload[payload.key],
            ...payload.data,
          },
        },
      };
    case CHECKOUT_SET_CUSTOMER_INFO:
      return {
        ...state,
        payload: {
          ...state.payload,
          [payload.key]: {
            ...state.payload[payload.key],
            ...payload.data,
          },
        },
      };
    case CHECKOUT_SET_DELIVERY:
    case CHECKOUT_SET_PAYMENT:
    case CHECKOUT_SET_ORDER_NOTE:
    case CHECKOUT_SET_B2C_ZIP_CODE:
    case CHECKOUT_SET_B2C_ZIP_CODE_SUCCESS:
    case CHECKOUT_SET_PAYMENT_WIDGET:
    case CHECKOUT_SET_PRIVATE_CUSTOMER:
    case CHECKOUT_SET_SIGN_UP:
    case CHECKOUT_SET_SELECTED_COMPANY_ADDRESS:
    case CHECKOUT_ACCEPT_TERMS_OF_CONDITION:
    case CHECKOUT_ACCEPT_NEWS_LETTER_SIGN_UP:
    case CHECKOUT_SET_DISCOUNT_CODE:
    case CHECKOUT_SET_COUNTRY:
    case CHECKOUT_SET_USED_DISCOUNT_CODE:
    case CHECKOUT_SET_SHOW_ALTERNATIVE_ADDRESS:
    case CHECKOUT_VALIDATE_ADDRESS:
    case CHECKOUT_SET_SELECTED_DELIVERY_ADDRESS:
    case CHECKOUT_SET_SELECTED_BILLING_ADDRESS:
      return {
        ...state,
        payload: {
          ...state.payload,
          ...payload,
        },
      };
    default:
      return state;
  }
};
